import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Select from 'react-select';
const AdditionalSelectInput = ({ options, onChange, selectedOption }) => {
    const handleChange = (e) => {
        if (e) {
            onChange(e);
        }
    };
    const customStyles = {
        control: (defaultStyles, state) => (Object.assign(Object.assign({}, defaultStyles), { boxShadow: state.isFocused ? '0px 4px 12px rgba(31, 121, 245, 0.12)' : 0, backgroundColor: 'var(--main-background-header)', maxHeight: '6rem', borderColor: state.isFocused ? '#a6865b' : 'var(--line-color)', minWidth: '13rem', '&:hover': {
                borderColor: '#a6865b'
            } })),
        menu: (defaultStyles) => (Object.assign(Object.assign({}, defaultStyles), { zIndex: 1000, padding: 5, backgroundColor: 'var(--main-background-header)', '& .css-pep2w9-option': {
                backgroundColor: 'var(--main-background-header)'
            } })),
        option: (defaultStyles) => (Object.assign(Object.assign({}, defaultStyles), { borderRadius: 5, backgroundColor: 'var(--main-background-header)', color: 'var(--main-color)', '&:hover': {
                backgroundColor: 'var(--line-color)'
            }, '&:focus': {
                backgroundColor: 'var(--line-color)'
            }, '&:active': {
                backgroundColor: 'var(--line-color)'
            } })),
        valueContainer: (provided) => (Object.assign(Object.assign({}, provided), { maxHeight: '6rem', '& .css-6j8wv5-Input': {
                maxHeight: '6rem',
                padding: 0,
                margin: 0
            } })),
        indicatorSeparator: (provided) => (Object.assign(Object.assign({}, provided), { display: 'none' })),
        singleValue: (provided) => (Object.assign(Object.assign({}, provided), { fontFamily: 'urbanist', color: 'var(--main-color)' }))
    };
    return (options && (_jsx(Select, { styles: customStyles, defaultValue: {
            label: selectedOption || 'Select',
            value: selectedOption || 'Select'
        }, onChange: (e) => handleChange(e), options: options })));
};
export default AdditionalSelectInput;
